export const coreDataStore = {
  core_data: null as any,
};
